import type { ReactNode } from 'react';
import { cn } from '@/lib/classNames';

interface FormFieldProps {
  label: string;
  htmlFor?: string;
  error?: string;
  children: ReactNode;
  className?: string;
}

/** Label + control + inline error, styled to match the app's form layout. */
export function FormField({ label, htmlFor, error, children, className }: FormFieldProps) {
  return (
    <div className={cn('ast-field', className)}>
      <label className="ast-field-label" htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      {error && <div className="ast-field-error">{error}</div>}
    </div>
  );
}
